<template>
    <div class="withdraw-container">
        <v-container v-if="refWithdrawEnable === 0" style="background: #effafc;">
            <div class="container-tabs">
                <h1 style="position: relative;height: 50px;top: 50%;left: 40%;">Rút tiền đang được bảo trì</h1>
            </div>
        </v-container>
        <v-container v-else fluid grid-list-lg>
            <v-row>
                <v-col>
                    <v-card class="deposit pa-2 white--text text-center bg-gradient" outlined :to="{ name: 'user_widthdraw', params: {type: 'process'}}" @click="type='process'">
                        <v-icon color="white" large>mdi-credit-card-plus-outline</v-icon><br />
                        <span class="mt-3">Rút tiền</span><br />
                        <span class="mt-1">{{ gem | formatNumber }} GEM</span>
                    </v-card>
                    <div v-if="type==='process'" class="bg-gradient div-flag"></div>
                </v-col>
                <v-col>
                    <v-card class="fanpage pa-2 white--text text-center bg-gradient" outlined :to="{ name: 'user_widthdraw', params: {type: 'log'}}" @click="type='log'">
                        <v-icon color="white" large>mdi-history</v-icon><br />
                        <span>Lịch sử</span><br />
                        <span>Rút tiền</span>
                    </v-card>
                    <div  v-if="type==='log'" class="bg-gradient div-flag"></div>
                </v-col>
            </v-row>
            <div v-if="type==='process'" class="tab-withdraw">
                <v-row>
                    <v-col>
                        <v-card class="notice pa-2 white--text bg-gradient" outlined >
                            <p>
                                <span class="font-weight-bold">Lưu ý:</span><br>
                                - Duyệt tiền 24/24 ngay khi nhận được yêu cầu rút tiền.<br>
                                - Các lệnh rút tiền vào Thứ 7, Chủ Nhật sẽ chậm hơn các ngày trong tuần.
                            </p>
                        </v-card>
                    </v-col>
                </v-row>

                <!--videoRef-->
                <div class="pl-5" v-if="videoId">
                    <div class="v-sheet theme--light explain">
                        <a href="#videoRef">
                            <span class="blue_text label-highlight">Video hướng dẫn rút tiền</span>
                        </a>
                    </div>
                </div>
                
                <v-row>
                    <h3 class="ml-7 mt-3 title">Phương thức</h3><br>
                </v-row>
                <v-row>
                    <v-col cols="12" >
                        <v-card class="pa-2 bg-white" outlined >
                            <span class="mb-4 font-weight-bold">Chọn phương thức rút tiền</span><br>
                            <span class="mb-2">Rút tiền qua</span>
                            <v-select
                                solo
                                :items="methods"
                                v-model="method"
                                item-text="name"
                                item-value="value"
                            ></v-select>
                        </v-card>
                    </v-col>
                </v-row>
                <v-row>
                    <h3 class="ml-7 title">Thông tin thanh toán</h3><br>
                </v-row>
                <v-row>
                    <v-col cols="12">
                        <v-card class="pa-2 bg-white" outlined >
                            <v-form ref="form_user_withdraw_0">

                                <!--                                loai 0: GEM -> coin-->
                                <div v-if="showComming===0" class="method-gem">
                                    <span class="mb-2">Số GEM</span>
                                    <v-text-field
                                        v-model="money0"
                                        solo
                                        required
                                        type="number"
                                        :rules="money0Rules"
                                    ></v-text-field>

                                    <span class="mb-2">Mật khẩu đăng nhập</span>
                                    <v-text-field
                                        solo
                                        v-model="password0"
                                        type="password"
                                        required
                                        :rules="passwordRules"
                                    ></v-text-field>
                                </div>
                            </v-form>

                            <!--                                loai 1: ngan hang-->
                            <v-form ref="form_user_withdraw_1">
                                <div v-if="showComming===1" class="method-bank">
                                    <span class="mb-2">Ngân hàng</span>
                                    <v-autocomplete
                                        solo
                                        v-model="bankName"
                                        :items="bankNames"
                                        item-text="name"
                                        item-value="value"
                                        label="Gõ để tìm kiếm ngân hàng nhanh hơn"
                                        required
                                        :rules="bankNameRules"
                                    ></v-autocomplete>
                                    <span class="mb-2">Tên chủ thẻ</span>
                                    <v-text-field
                                        v-model="nameAccount"
                                        solo
                                        required
                                        type="text"
                                        :rules="nameAccountRules"
                                    ></v-text-field>
                                    <span class="mb-2">Số tài khoản</span>
                                    <v-text-field
                                        v-model="noAccount"
                                        solo
                                        required
                                        type="number"
                                        :rules="noAccountRules"
                                    ></v-text-field>
                                    <span class="mb-2">Chi nhánh</span>
                                    <v-text-field
                                        v-model="branchName"
                                        solo
                                        required
                                        type="text"
                                        :rules="branchNameRules"
                                    ></v-text-field>
                                    <span class="mb-2">Số tiền</span>
                                    <v-select
                                        v-model="money1"
                                        solo
                                        :items="money1s"
                                        item-text="name"
                                        item-value="value"
                                    ></v-select>
                                    <span class="mb-2">Mật khẩu đăng nhập</span>
                                    <v-text-field
                                        solo
                                        v-model="password1"
                                        type="password"
                                        required
                                        :rules="passwordRules"
                                    ></v-text-field>
                                </div>
                            </v-form>
                            <!--                                loai 4: the garena-->
                            <v-form ref="form_user_withdraw_4">
                                <div v-if="showComming===4" class="method-sdt">
                                    <span class="mb-2">Số tiền cần rút</span>
                                    <v-select
                                        solo
                                        :items="money4s"
                                        v-model="money4"
                                        item-text="name"
                                        item-value="value"
                                    ></v-select>
                                    <span class="mb-2">Nhập mã rút tiền Garena</span>
                                    <v-text-field
                                        v-model="nameAccount4"
                                        solo
                                        required
                                    ></v-text-field>
                                    <span class="mb-2">Mật khẩu đăng nhập</span>
                                    <v-text-field
                                        solo
                                        v-model="password4"
                                        type="password"
                                        required
                                        :rules="passwordRules"
                                    ></v-text-field>
                                </div>
                            </v-form>
                            <!--                                loai 5: the dt-->
                            <v-form ref="form_user_withdraw_5">
                                <div v-if="showComming===5" class="method-sdt">
                                    <span class="mb-2">Chọn nhà mạng</span>
                                    <v-select
                                            solo
                                            :items="homeNetworks"
                                            v-model="homeNetwork"
                                            item-text="name"
                                            item-value="value"
                                            @change="setMobileDenoms()"
                                    ></v-select>
                                    <span class="mb-2">Loại hình</span>
                                    <v-select
                                            solo
                                            :items="simTypes"
                                            v-model="simType"
                                            item-text="name"
                                            item-value="value"
                                    ></v-select>
                                    <span class="mb-2">Chọn mệnh giá</span>
                                    <v-select
                                            solo
                                            :items="mobileDenoms"
                                            v-model="mobileDenom"
                                            item-text="name"
                                            item-value="value"
                                    ></v-select>
                                    <span class="mb-2">Số điện thoại</span>
                                    <v-text-field
                                            v-model="mobile"
                                            solo
                                            :counter="11"
                                            required
                                            type="number"
                                            :rules="mobileRules"
                                    ></v-text-field>
                                    <span class="mb-2">Mật khẩu đăng nhập</span>
                                    <v-text-field
                                            solo
                                            v-model="password5"
                                            type="password"
                                            required
                                            :rules="passwordRules"
                                    ></v-text-field>
                                </div>
                            </v-form>
                            <!--                                loai 7: Momo-->
                            <v-form ref="form_user_withdraw_7">
                                <div v-if="showComming===7" class="method-sdt">
                                    <span class="mb-2">Số tiền cần rút</span>
                                    <v-select
                                        solo
                                        :items="money7s"
                                        v-model="money7"
                                        item-text="name"
                                        item-value="value"
                                    ></v-select>
                                    <span class="mb-2">Số điện thoại</span>
                                    <v-text-field
                                        v-model="mobile7"
                                        solo
                                        :counter="11"
                                        required
                                        type="number"
                                        :rules="mobileRules"
                                    ></v-text-field>
                                    <span class="mb-2">Họ và tên</span>
                                    <v-text-field
                                        v-model="nameAccount7"
                                        solo
                                        required
                                        type="text"
                                        :rules="nameAccountRules"
                                    ></v-text-field>
                                    <span class="mb-2">Mật khẩu đăng nhập</span>
                                    <v-text-field
                                        solo
                                        v-model="password7"
                                        type="password"
                                        required
                                        :rules="passwordRules"
                                    ></v-text-field>
                                </div>
                            </v-form>
                            <!--                                loai 8: Nạp tiền cho hacklikefb-->
                            <v-form ref="form_user_withdraw_8">
                                <div v-if="showComming===8" class="method-sdt">
                                    <span class="mb-2">Số tiền cần rút</span>
                                    <v-text-field
                                        v-model="money8"
                                        solo
                                        required
                                        type="number"
                                        :rules="moneyRules"
                                    ></v-text-field>
                                    <span class="mb-2">Nhập tài khoản hacklikefb.net (username đăng nhập)</span>
                                    <v-text-field
                                        v-model="nameAccount8"
                                        solo
                                        required
                                    ></v-text-field>
                                    <span class="mb-2">Mật khẩu đăng nhập</span>
                                    <v-text-field
                                        solo
                                        v-model="password8"
                                        type="password"
                                        required
                                        :rules="passwordRules"
                                    ></v-text-field>
                                </div>
                            </v-form>
                            <div v-if="showComming === -1">
                                <span class="red--text">Chưa hỗ trợ hình thức rút tiền này</span>
                            </div>

                        </v-card>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="12">
                        <v-btn width="100%" height="50px" color="blue" class="white--text" @click="withDraw()">
                            Rút Tiền
                        </v-btn>
                    </v-col>
                </v-row>

                <!--video youtube-->
                <v-row align-center row v-if="videoId" id="videoRef">
                    <v-flex md8>
                        <div class="col-sm-12 mb-n3">
                            <h3 class="text-color">HƯỚNG DẪN SỬ DỤNG</h3>
                        </div>
                        <div class="col-sm-12 mb-n3">
                            <youtube :video-id="videoId" ref="youtube"
                                     @buffering="playing"
                                     @paused="paused"
                                     @ended="paused"
                                     @playing="playing"
                                     width="100%" height="650px">
                            </youtube>
                        </div>
                    </v-flex>
                </v-row>

            </div>

            <div  v-if="type==='log'" class="tab-log-withdraw">

                <v-layout row>
                    <v-flex xs12>

                        <v-card>
                            <v-card-title>
                                Lịch Sử rút tiền
                                <v-spacer></v-spacer>
                            </v-card-title>
                            <div id="log-withdraw-activity-log">
                                <v-data-table
                                    :headers="headers"
                                    :items="desserts"
                                    :options.sync="options"
                                    :server-items-length="totalDesserts"
                                    :loading="loading"
                                    class="elevation-1"
                                >
                                    <template v-slot:item.money = "{item}">
                                        <v-chip color="orange" dark>
                                            {{ item.money | formatNumber }} GEM
                                        </v-chip>
                                    </template>
                                    <template v-slot:item.status_message="{ item }">
                                        <v-chip v-if="item.status == 1" color="orange" dark>
                                            <v-avatar left>
                                                <v-icon>mdi-sync</v-icon>
                                            </v-avatar>
                                            {{ item.status_message }}
                                        </v-chip>
                                        <v-chip v-if="item.status == 2" color="success" dark>
                                            <v-avatar left>
                                                <v-icon>mdi-check</v-icon>
                                            </v-avatar>
                                            {{ item.status_message }}
                                        </v-chip>
                                        <v-chip v-if="item.status == 3" color="secondary" dark>
                                            <v-avatar left>
                                                <v-icon>mdi-close-circle</v-icon>
                                            </v-avatar>
                                            {{ item.status_message }}
                                        </v-chip>
                                    </template>

                                </v-data-table>
                            </div>


                        </v-card>
                    </v-flex>
                </v-layout>

            </div>

        </v-container>
    </div>
</template>

<script>
    import {
        WITHDRAW_LIST_METHOD,
        WITHDRAW_DETAIL_FORM,
        WITHDRAW_POST_FORM,
        AUTH_USER,
        CONFIG_PAGE,
        CONFIG_OTHER_PAGE
    } from "~/store/actions.type";
    import {formatCurrency} from "~/common/helper.string";
    import Swal from 'sweetalert2';

    export default {
        data() {
            return {
                // history
                refWithdrawEnable: 1,
                totalDesserts: 0,
                desserts: [],
                loading: true,
                options: {},
                headers: [
                    { text: 'ID', value: 'id'},
                    { text: 'Số tiền', value: 'money', align: "center"},
                    { text: 'Ngày rút', value: 'created_at',  align: "center"},
                    { text: 'Phương thức', value: 'form_convert', align: "center" },
                    { text: 'Số điện thoại', value: 'mobile_convert', align: "center"  },
                    { text: 'Trạng thái', value: 'status_message', align: "center"  },
                    { text: 'Ghi chú', value: 'note', align: "center"  },
                ],
                status: [],
                // process
                type: '',
                method:0,
                methods: [],
                showComming: 0,
                detailForm:[],
                // Rut loai 1: ngan hang
                bankNames: [],
                bankName: "",
                bankNameRules: [
                    v => !!v || 'Vui lòng chọn ngân hàng'
                ],
                nameAccount:"",
                nameAccountRules: [
                    v => !!v || 'Vui lòng nhập Tên chủ thẻ'
                ],
                noAccount:"",
                noAccountRules: [
                    v => !!v || 'Vui lòng nhập Số tài khoản'
                ],
                branchName:"",
                branchNameRules: [
                    v => !!v || 'Vui lòng nhập Chi nhánh'
                ],

                //loai 0: GEM -> coin
                money0: '',
                password0: '',
                money0Rules: [
                    v => !!v || 'Vui lòng nhập số GEM'
                ],

                money1s: [],
                money1: 5,
                password1: '',

                // rut ra the dt: loai 5
                homeNetwork:1, // vietel
                homeNetworks: [],
                simType:0,
                simTypes: [],
                mobileDenom: 2, // min 20k cua vietel
                mobileDenoms:[],
                mobileDenomAll:[],
                mobile: '',
                mobileRules: [
                    v => !!v || 'Vui lòng nhập số điện thoại liên hệ',
                    v => (v && v.length <= 11 && v.length >=10) || 'Số điện thoại trong khoản 10-11 ký tự',
                ],
                password5: '',

                //rut ra bang momo: loai 7
                money7s: [],
                money7: 5,
                mobile7: '',
                nameAccount7: '',
                password7: "",

                // rút tiền bằng garena
                money4s: [],
                money4: 4,
                nameAccount4: '',
                password4: "",
                // Nạp tiền cho hacklike
                money8s: [],
                money8: '',
                nameAccount8: '',
                password8: "",
                //Common
                moneyRules: [
                    v => !!v || 'Vui lòng nhập Số tiền'
                ],
                passwordRules: [
                    v => !!v || 'Vui lòng nhập Mật khẩu'
                ],

                videoId: '',
                videoStatus: true,

            }
        },
        filters : {
            formatNumber(num) {
                return num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
            }
        },
        created() {
            this.type = this.$route.params.type;
        },
        watch: {
            method() {
                this.getDetailForm();
            },
            options: {
                handler () {
                    this.getDataHistoryFromApi()
                    .then(data => {
                        this.desserts = data.items
                        this.totalDesserts = data.total
                    })
                },
                deep: true,
            },

        },
        computed: {
            gem() {
                return this.$store.getters.gem;
            }
        },
        methods: {
            async getDataFromApi () {
                await this.$store.dispatch(CONFIG_PAGE).then((data) => {
                    let refWithdrawStatus = data.filter(o => o.key == 'key_cp_ref_withdraw');
                    this.refWithdrawEnable = parseInt(refWithdrawStatus[0]['status']);
                });

                this.data = await this.$store.dispatch(CONFIG_OTHER_PAGE);
                for (let i = 0; i < this.data.length; i++) {
                    if (this.data[i].type === 'user_withdraw') {
                        if (this.data[i].video) {
                            let videoId = this.youtube_parser(this.data[i].video);
                            if (videoId) {
                                this.videoId = videoId;
                            }
                        }
                    }
                }

                let dataMethod = await this.$store.dispatch(WITHDRAW_LIST_METHOD);
                if (dataMethod !== false) {
                    let dataArr = Object.values(dataMethod.form_convert_list);
                    // Set method
                    for(let i=0; i< dataArr.length; i++) {

                        this.methods.push({
                            name:  dataArr[i],
                            value:  i
                        });
                    }
                    this.getDetailForm();
                }
            },
            async getDataHistoryFromApi () {
                let dataMethod = await this.$store.dispatch(WITHDRAW_LIST_METHOD);
                // history
                this.loading = true
                const { sortBy = [], sortDesc = [], page, itemsPerPage } = this.options

                let items =  dataMethod.history_convert_money;
                const total = items.length

                if (sortBy.length === 1 && sortDesc.length === 1) {
                    items = items.sort((a, b) => {
                        const sortA = a[sortBy[0]]
                        const sortB = b[sortBy[0]]

                        if (sortDesc[0]) {
                            if (sortA < sortB) return 1
                            if (sortA > sortB) return -1
                            return 0
                        } else {
                            if (sortA < sortB) return -1
                            if (sortA > sortB) return 1
                            return 0
                        }
                    })
                }
                if (itemsPerPage > 0) {
                    items = items.slice((page - 1) * itemsPerPage, page * itemsPerPage)
                }

                this.loading = false;
                return {items,total};

            },
            async getDetailForm(){

                let dataDetail = await this.$store.dispatch(WITHDRAW_DETAIL_FORM, {form_convert_id: this.method});
                if (dataDetail !== false) {
                    this.showComming = this.method;
                    switch (this.method) {
                        case 0: // doi GEM -> coin
                            break;
                            
                        case 1: // ngan hang
                            for(let i=0; i< Object.values(dataDetail.banks).length; i++) {
                                this.bankNames.push({name:  Object.values(dataDetail.banks)[i], value:  i });
                            }
                            for(let i=0; i< Object.values(dataDetail.mobile_denominations).length; i++) {
                                this.money1s.push({
                                    name:  formatCurrency(Object.values(dataDetail.mobile_denominations)[i]) + " VND",
                                    value:  i+5,
                                    nameValue:Object.values(dataDetail.mobile_denominations)[i]
                                });
                            }
                            break;

                        case 5: // the dt

                            for(let i=0; i< Object.values(dataDetail.mobile_denominations).length; i++) {
                                this.homeNetworks.push({
                                    name:  Object.values(dataDetail.mobile_denominations)[i].name,
                                    value:  Object.values(dataDetail.mobile_denominations)[i].id
                                });
                            }

                            for(let i=0; i< Object.values(dataDetail.mobile_denom_all).length; i++) {
                                this.mobileDenomAll.push({
                                    name:  formatCurrency(Object.values(dataDetail.mobile_denom_all)[i].value)
                                        + " "+dataDetail.unit,
                                    value:  i+1,
                                    nameValue: Object.values(dataDetail.mobile_denom_all)[i].value
                                });
                            }

                            for(let i=0; i< Object.values(dataDetail.simtypes).length; i++) {
                                this.simTypes.push({name:  Object.values(dataDetail.simtypes)[i], value:  i });
                            }

                            this.setMobileDenoms();
                            break;
                            
                        case 4: // garena
                            for(let i=0; i< Object.values(dataDetail.mobile_denominations).length; i++) {
                                this.money4s.push({name:  formatCurrency(Object.values(dataDetail.mobile_denominations)[i]) + " VND", value:  i+5, nameValue:Object.values(dataDetail.mobile_denominations)[i]});
                            }
                            break;
                            
                        case 7: // momo
                            for(let i=0; i< Object.values(dataDetail.mobile_denominations).length; i++) {
                                this.money7s.push({name:  formatCurrency(Object.values(dataDetail.mobile_denominations)[i]) + " VND", value:  i+5, nameValue:Object.values(dataDetail.mobile_denominations)[i]});
                            }
                            break;
                            
                        case 8: // hacklikefb
                            break;
                            
                        default:
                            this.showComming = -1;
                    }

                } else {
                    this.showComming = -1;
                }
            },
            // Fix nap dien thoai
            // Fix nap dien thoai
            setMobileDenoms() {
                this.mobileDenoms = [];
                let denomValueArray = Object.values(this.dataDetail.mobile_denominations)[this.homeNetwork-1].denom_value;

                this.mobileDenom = denomValueArray[0].id;
                for(let i=0; i< denomValueArray.length; i++) {
                    this.mobileDenoms.push({
                        name: formatCurrency(denomValueArray[i].val) +" VND",
                        value: denomValueArray[i].id,
                        nameValue: denomValueArray[i].val,
                    });
                }
            },
            getParams(method) {
                let param = [];
                switch (method) {
                    case 0:
                        param = {
                            form_convert_id: 0,
                            money: this.money0,
                            password: this.password0
                        };
                        break;
                    case 1: // ngan hang
                        param = {
                            form_convert_id: 1,
                            bank_name: this.bankNames[this.bankName].name,
                            branch_name: this.branchName,
                            account_name: this.nameAccount,
                            account_id: this.noAccount,
                            money: this.money1s[this.money1-5].nameValue,
                            password: this.password1,
                        };
                        break;
                    case 4: // momo
                        param = {
                            form_convert_id: 4,
                            money: this.money4s[this.money4-5].nameValue,
                            name: this.nameAccount4,
                            password: this.password4,
                        };
                        break;
                    case 5: // the dt
                        param = {
                            form_convert_id: 5,
                            money: this.mobileDenomAll[this.mobileDenom-1].nameValue,
                            mobile: this.mobile,
                            home_network_id: this.homeNetwork,
                            simtype: this.simType,
                            password: this.password5,
                        };
                        break;
                    case 7: // momo
                        param = {
                            form_convert_id: 7,
                            money: this.money7s[this.money7-5].nameValue,
                            mobile: this.mobile7,
                            name: this.nameAccount7,
                            password: this.password7,
                        };
                        break;
                    case 8: // nạp tiền cho account hacklike
                        param = {
                            form_convert_id: 8,
                            money: this.money8,
                            name: this.nameAccount8,
                            password: this.password8,
                        };
                        break;
                    default:
                }
                return param;
            },
            getHmlConfirm(method) {
                let html ='';
                switch (method) {
                    case 0: // GEM -> coin
                        html = "<h2>" +
                            "Số tiền: " + formatCurrency(parseInt(this.money0)) + " coin - " +
                            "tương ứng với số GEM: " + formatCurrency(parseInt(this.money0))  +
                            "</h2>";
                        break;
                    case 1: // ngan hang
                        html = "<h2>" +
                            "Ngân hàng: " + this.bankNames[this.bankName].name + "<br>" +
                            "Tên chủ thẻ: " + this.nameAccount + "<br>" +
                            "Số tài khoản: " + this.noAccount + "<br>" +
                            "Chi nhánh: " + this.branchName + "<br>" +
                            "Số tiền: " + this.money1s[this.money1-5].name + " - " +
                            "tương ứng với số GEM: " + formatCurrency(parseInt(this.money1s[this.money1-5].nameValue))  +
                            "</h2>";
                        break;
                    case 4: // Thẻ garena
                        html = "<h2>" +
                            "Tài khoản Garena" + this.nameAccount4 + "<br>" +
                            "Mệnh giá: " + this.money4s[this.money4-5].name + " - " +
                            "tương ứng với số GEM: " + formatCurrency(parseInt(this.money4s[this.money4-5].nameValue))  +
                            "</h2>";
                        break;
                    case 5: // the dt
                        html = "<h2>" +
                            "Số điện thoại: " + this.mobile + "<br>" +
                            "Nhà mạng: " + this.homeNetworks[this.homeNetwork-1].name + "<br>" +
                            "Loại hình: " + this.simTypes[this.simType].name + "<br>" +
                            "Mệnh giá: " + this.mobileDenomAll[this.mobileDenom-1].name + " - " +
                            "tương ứng với số GEM: " + formatCurrency(parseInt(this.mobileDenomAll[this.mobileDenom-1].nameValue) * this.gem)  +
                            "</h2>";
                        break;
                    case 7: // momo
                        html = "<h2>" +
                            "Số điện thoại: " + this.mobile7 + "<br>" +
                            "Tên Momo: " + this.nameAccount7 + "<br>" +
                            "Mệnh giá: " + this.money7s[this.money7-5].name + " - " +
                            "tương ứng với số GEM: " + formatCurrency(parseInt(this.money7s[this.money7-5].nameValue))  +
                            "</h2>";
                        break;
                    case 8: // Hacklike
                        html = "<h2>" +
                            "Tài khoản customer hacklikefb.net " + this.nameAccount8 + "<br>" +
                            "Số tiền: " + formatCurrency(parseInt(this.money1)) + " coin - " +
                            "tương ứng với số GEM: " + formatCurrency(parseInt(this.money8))  +
                            "</h2>";
                        break;
                    default:
                }
                return html;
            },
            validateForm(method) {
                let validate = false;
                switch (method) {
                    case 0: // GEM -> coin
                        validate = this.$refs.form_user_withdraw_0.validate()
                        break;
                    case 1: // ngan hang
                        validate = this.$refs.form_user_withdraw_1.validate()
                        break;
                    case 4: // the garena
                        validate = this.$refs.form_user_withdraw_4.validate()
                        break;
                    case 5: // the dt
                        validate = this.$refs.form_user_withdraw_5.validate()
                        break;
                    case 7: // momo
                        validate = this.$refs.form_user_withdraw_7.validate()
                        break;
                    case 8: // hacklike
                        validate = this.$refs.form_user_withdraw_8.validate()
                        break;
                    default:
                }
                return validate;

            },
            withDraw(){
                if (this.validateForm(this.method)) {
                    Swal.fire({
                        title: 'Bạn có chắc chắn muốn rút tiền với thông tin:',
                        html: this.getHmlConfirm(this.method),
                        icon: 'warning',
                        showCancelButton: true,
                        confirmButtonColor: '#3085d6',
                        cancelButtonColor: '#d33',
                        confirmButtonText: 'Vâng , chính xác!',
                        cancelButtonText: 'Không'
                    }).then((result) => {
                        if (result.value) {
                            this.$store.dispatch(WITHDRAW_POST_FORM, this.getParams(this.method)).then(res =>{
                                if(res) {
                                    let aThis = this;
                                    this.$store.dispatch(AUTH_USER);
                                    setTimeout(function () {
                                        aThis.$router.go();
                                    }, 3000);
                                }
                            });

                        }
                    })
                }
            },
            
            playing() {
                this.videoStatus = false;
            },
            paused() {
                this.videoStatus = true;
            },
            youtube_parser(url) {
                let regExp = /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#&?]*).*/;
                let match = url.match(regExp);
                return (match && match[7].length == 11) ? match[7] : false;
            }
        },
        mounted() {
            this.getDataFromApi();
            this.getDataHistoryFromApi()
            .then(data => {
                this.desserts = data.items
                this.totalDesserts = data.total
            })
        }
    };
</script>
<style scoped lang="scss">
    .withdraw-container {
        .goto-link {
            text-decoration: unset;
            color: unset;
        }
        .v-card {
            border-radius: 15px;
            border: none;
        }
        .v-card.bg-gradient {
            background: linear-gradient(51.19deg, #0084F8 9.02%, #58C2F1 90.81%);
        }
        .v-list__group__header__prepend-icon .v-icon {
            color: red !important;
        }
        .v-card.notice {
            background: linear-gradient(69.69deg, #FF8576 9.02%, #FF3B30 90.81%);
        }
        .title {
            color: #0084F8;
        }
        .div-flag {
            width: 100%;
            height: 3px;
            background: linear-gradient(51.19deg, #0084F8 9.02%, #58C2F1 90.81%);
            margin-top: 3px;
        }

    }


</style>
